import * as React from 'react';
/**
 *
 * Original name: puzzle piece
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A389
 *
 */
export const PuzzlePiecePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M49 28h-2V17H36v-2c0-4.383-2.617-7-7-7s-7 2.617-7 7v2H11v36h15v-6c0-2.187.813-3 3-3 2.187 0 3 .813 3 3v6h15V42h2c4.383 0 7-2.617 7-7s-2.617-7-7-7Zm0 10h-6v11h-7v-2c0-4.383-2.617-7-7-7s-7 2.617-7 7v2h-7V21h11v-6c0-2.187.813-3 3-3 2.187 0 3 .813 3 3v6h11v11h6c2.187 0 3 .813 3 3 0 2.187-.813 3-3 3Z", fill: "currentColor" })));
